import { createContext } from 'react'

interface TopCommentAPIContextType {
  topComments: Comment[] | any
}

const TopCommentAPIContext = createContext<TopCommentAPIContextType>(
  {} as TopCommentAPIContextType
)

export default TopCommentAPIContext
